export default "__VITE_ASSET__1504d3f8__"